import React, { useEffect, useState } from "react";
import { Container, Grid, Box, Typography, CircularProgress } from "@material-ui/core";
import { Logger } from "aws-amplify";
import { AmplifyAPI } from "./api/amplify-api";
import { EmployeeAndVideoDetails } from "../shared/types/EmployeeAndVideoDetails";
import { useTranslation } from "react-i18next";
import { pvpStyles } from "./pvp.styles";
import HeaderArea from "./sections/header-area/HeaderArea";
import EmployeeArea from "./sections/employee-area/EmployeeArea";
import FooterArea from "./sections/footer-area/FooterArea";

const logger = new Logger("UserPVP")

const UserPVP = (props: any) => {
    const style = pvpStyles();
    const { t, i18n } = useTranslation();
    const userId = props.match.params.userId;

    const [details, setDetails] = useState<EmployeeAndVideoDetails | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [fatalError, setFatalError] = useState<boolean>(false);

    useEffect(() => {
        if (!userId) {
            setFatalError(true);
            setLoading(false);
            return;
        }
        AmplifyAPI.getUserById(userId)
            .then((result: EmployeeAndVideoDetails) => {
                if (result.video?.user?.locale) {
                    i18n.changeLanguage(result.video.user.locale.substr(0, 2));
                }
                setDetails(result);
                logger.debug("Loaded user details", result);
            })
            .catch((err: any) => {
                logger.error("Failed to load user details", err);
                // Don't block the page - still show "video unavailable" message
            })
            .finally(() => {
                setLoading(false);
            });
        // eslint-disable-next-line
    }, [userId]);

    // Only show blank error if no userId at all
    if (fatalError) {
        return (
            <Container maxWidth="sm" disableGutters={true}>
                <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
                    <Typography variant="h6" style={{ color: '#555', textAlign: 'center', padding: '2rem' }}>
                        {t('videoNotAvailable')}
                    </Typography>
                </Box>
            </Container>
        );
    }

    if (loading) {
        return (
            <Container maxWidth="sm" disableGutters={true}>
                <CircularProgress
                    className={style.circularProgress}
                    thickness={6}
                    size='4rem'
                />
            </Container>
        );
    }

    return (
        <Container maxWidth="sm" disableGutters={true}>
            <Grid container justify="flex-start" alignItems="stretch" className={style.root}>
                {details && (
                    <Grid item xs={12} className={style.header}>
                        <HeaderArea employeeAndVideo={details} />
                    </Grid>
                )}

                <Grid item xs={12} className={style.body}>
                    <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        style={{
                            minHeight: '200px',
                            backgroundColor: '#000',
                        }}
                    >
                        <Typography
                            variant="h6"
                            style={{
                                color: '#fff',
                                textAlign: 'center',
                                padding: '2rem'
                            }}
                        >
                            {t('videoNotAvailable')}
                        </Typography>
                    </Box>
                </Grid>

                {details && (
                    <Grid item xs={12} className={style.footerEmployee}>
                        <EmployeeArea employeeAndVideo={details} />
                    </Grid>
                )}

                {details && (
                    <Grid item xs={12} className={style.footerMaps}>
                        <FooterArea employeeAndVideo={details} />
                    </Grid>
                )}
            </Grid>
        </Container>
    );
};

export default UserPVP;
